import React, { useEffect, useMemo, useState } from "react";
import { StreamChat } from "stream-chat";
import { Channel, ChannelList, Chat } from "stream-chat-react";
import "stream-chat-react/dist/css/index.css";
import config from "../config";
import { useCongress, useUserMe } from "../hooks";
import {
  CreateChannel,
  CustomMessage,
  MessagingChannelList,
  MessagingChannelPreview,
  MessagingInput,
  MessagingThreadHeader
} from "./chat";
import { ChannelInner } from "./chat/ChannelInner/ChannelInner";
import "./ChatApp.css";
import GiphyContext from "./GiphyContext";

const ChatApp = ({ open, onUnreadCountChange }) => {
  const { congress } = useCongress();
  const { user: userMe } = useUserMe();

  const apiKey = config.getStreamApiKey;
  const user = userMe?.profile?.id;
  const userToken = userMe?.profile?.getStreamToken;
  // const targetOrigin = urlParams.get('target_origin') || process.env.REACT_APP_TARGET_ORIGIN;

  const filters = {
    type: "messaging",
    $or: [{ members: { $in: [user] } }, { name: congress.name }]
  };
  const options = { state: true, watch: true, presence: true, limit: 8 };
  const sort = {
    last_message_at: -1,
    updated_at: -1,
    cid: 1
  };

  const userToConnect = useMemo(
    () => ({
      id: user,
      name: `${userMe?.profile?.firstName} ${userMe?.profile?.lastName}`,
      image: userMe?.profile?.avatarThumb
    }),
    [user, userMe?.profile?.avatarThumb, userMe?.profile?.firstName, userMe?.profile?.lastName]
  );

  const [chatClient, setChatClient] = useState(null);
  const [giphyState, setGiphyState] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  // const [isMobileNavVisible, setMobileNav] = useState(false);

  useEffect(() => {
    const initChat = async () => {
      try {
        const client = StreamChat.getInstance(apiKey);
        const chatUser = await client.connectUser(userToConnect, userToken);
        setChatClient(client);
        onUnreadCountChange({ unreadCount: chatUser.me.total_unread_count });
        client.on(event => {
          if (event.total_unread_count !== undefined) {
            onUnreadCountChange({ unreadCount: event.total_unread_count });
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    if (userToken && !chatClient) {
      initChat();
      return () => chatClient?.disconnectUser();
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatClient]);

  // useEffect(() => {
  //   const handleThemeChange = ({ data, origin }) => {
  //     // handle events only from trusted origin
  //     if (origin === targetOrigin) {
  //       if (data === 'light' || data === 'dark') {
  //         setTheme(data);
  //       }
  //     }
  //   };

  //   window.addEventListener('message', handleThemeChange);
  //   return () => window.removeEventListener('message', handleThemeChange);
  // }, []);

  // useEffect(() => {
  //   const mobileChannelList = document.querySelector("#mobile-channel-list");
  //   if (isMobileNavVisible && mobileChannelList) {
  //     mobileChannelList.classList.add("show");
  //     document.body.style.overflow = "hidden";
  //   } else if (!isMobileNavVisible && mobileChannelList) {
  //     mobileChannelList.classList.remove("show");
  //     document.body.style.overflow = "auto";
  //   }
  // }, [isMobileNavVisible]);

  // useEffect(() => {
  //   /*
  //    * Get the actual rendered window height to set the container size properly.
  //    * In some browsers (like Safari) the nav bar can override the app.
  //    *
  //   const setAppHeight = () => {
  //     const doc = document.documentElement;
  //     doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  //   };

  //   setAppHeight();

  //   window.addEventListener("resize", setAppHeight);
  //   return () => window.removeEventListener("resize", setAppHeight);
  // }, []);

  // const toggleMobile = () => setMobileNav(!isMobileNavVisible);

  const giphyContextValue = { giphyState, setGiphyState };

  if (!chatClient || !open) {
    return null;
  }

  return (
    <Chat client={chatClient} theme={`messaging ${congress.themeType}`}>
      {/* <div id="mobile-channel-list" onClick={toggleMobile}> */}
      <ChannelList
        filters={filters}
        sort={sort}
        options={options}
        List={props => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <MessagingChannelList {...props} onCreateChannel={() => setIsCreating(!isCreating)} />
        )}
        // eslint-disable-next-line react/jsx-props-no-spreading
        Preview={props => <MessagingChannelPreview {...props} {...{ setIsCreating }} />}
      />
      {/* </div> */}
      <div>
        <Channel
          Input={MessagingInput}
          maxNumberOfFiles={10}
          Message={CustomMessage}
          multipleUploads
          ThreadHeader={MessagingThreadHeader}
          TypingIndicator={() => null}
        >
          {isCreating && (
            // <CreateChannel toggleMobile={toggleMobile} onClose={() => setIsCreating(false)} />
            <CreateChannel toggleMobile={() => {}} onClose={() => setIsCreating(false)} />
          )}
          <GiphyContext.Provider value={giphyContextValue}>
            {/* <ChannelInner theme={theme} toggleMobile={toggleMobile} /> */}
            <ChannelInner theme={congress.themeType} toggleMobile={() => {}} />
          </GiphyContext.Provider>
        </Channel>
      </div>
    </Chat>
  );
};

export default ChatApp;
